import GridIcon from "../../../../../../../assets/svg/grid-icon";
import ListViewIcon from "../../../../../../../assets/svg/list-view-icon";
import { StageSortOption, SortKey, SortOrder } from "./types";
import { getHelpdeskLabels, getRegionLabel } from "../../../../../../../utils/constants/mappings";

export const HELPDESK_TICKETS_PAGE_SIZE = 10;

export const HELPDESK_VIEWS_PAGE_SIZE = 30;

export const SORT_OPTION_MAP: Record<
  StageSortOption,
  { sort_key: SortKey; sort_order: SortOrder }
> = {
  latest_updated: { sort_key: "updated_at", sort_order: "desc" },
  new_created: { sort_key: "created_at", sort_order: "desc" },
  sort_az: { sort_key: "ticket_title", sort_order: "asc" },
  sort_za: { sort_key: "ticket_title", sort_order: "desc" },
};

export const getExternalVendorOptions = (clientCode?: string): string[] => [
  "Concurrent",
  "Approval Max",
  "InsantOnIT",
  "ASK4",
  getRegionLabel("sales", clientCode),
  "Marketing",
  "Finance",
  "TransferMate",
  "Previous Managing Agent",
  "LAM",
  "QX",
  "Resident",
  "Lavanda",
];

export const PRIORITY_FILTER_OPTIONS = [
  {
    key: "high",
    label: "High",
  },
  {
    key: "medium",
    label: "Moderate",
  },
  {
    key: "low",
    label: "Low",
  },
];

export const ALL_TICKETS_VIEW = {
  id: "all_tickets",
  name: "All Tickets",
};

export const getAllTicketsView = (region?: string) => ({
  id: "all_tickets",
  name: getHelpdeskLabels(region).allTickets,
});

export const VIEW_SELECTOR_OPTIONS = [
  { id: "grid", icon: GridIcon, label: "Kanban" },
  { id: "list", icon: ListViewIcon, label: "List" },
];
